import { Elm } from './src/Main.elm'
import $ from 'jquery'

import 'normalize.css'
import 'animate.css'
import './assets/styles/skeleton.css'
import './assets/styles/main.scss'
import './assets/styles/nouislider.css'
import './assets/styles/breadcrumbs.scss'
import './assets/styles/preamble.scss'
import './assets/styles/current-supply.css'
import './assets/styles/current-usage.css'
import './assets/styles/payment-method.css'
import './assets/styles/projections.css'
import './assets/styles/switcher.css'
import './assets/styles/confirmation.css'

window.compareApp = function(flags) {
  var app = Elm.Main.init({
    node: document.getElementById('main'),
    flags: JSON.parse(flags)
  });

  document.querySelector('html').scrollTop = 0;

  app.ports.reportError.subscribe(function(err) {
    console.error(err);
    Rollbar.error(err);
  });

  app.ports.scrollTop.subscribe(function(a) {
    $('html, body, body > div').delay(400).animate({ scrollTop: 0 });
  });

  app.ports.scrollToValidationError.subscribe(function(a) {
    setTimeout(function() {
      var $err = $('.validation-error').first();
      var navH = $('.breadcrumbs').outerHeight();
      var top = $err.parent().offset().top;
      if (!$err.length) return;
      $('html, body').delay(400).animate({ scrollTop: top });
    }, 400);
  });

  app.ports.goToExternal.subscribe(function(url) {
    window.location = url;
  });

  app.ports.setRollbarUser.subscribe(function(email) {
    Rollbar.configure({ configure: { email: email } });
  });

  app.ports.pushPageName.subscribe(function(name) {
    dataLayer.push({ event: 'VirtualPageview', virtualPageURL: name });
  });

  app.ports.hideOverflows.subscribe(function() {
    setTimeout(function() {
      var visible = document.querySelectorAll('.fadeIn');
      var hidden = document.querySelectorAll('.fadeOut');

      for (var i = 0; i < visible.length; i++) {
        visible[i].style.display = 'block';
      }

      for (var i = 0; i < hidden.length; i++) {
        hidden[i].style.display = 'none';
      }
    }, 400);

  });

  var observer = new MutationObserver(function(mutations) {
    var insertedNodes = [];

    mutations.forEach(function(mutation) {
      for (var i = 0; i < mutation.addedNodes.length; i++) {
        insertedNodes.push(mutation.addedNodes[i]);
      }
    });

    insertEconomy7Slider(insertedNodes);
    insertPowershiftSlider(insertedNodes);
    setTariffsWidth(insertedNodes);
  });

  observer.observe(document.querySelector('body'), {
    childList: true,
    subtree: true
  });

  function insertEconomy7Slider(nodes) {
    var slider = nodes
      .map(function(n) { return n.querySelector && n.querySelector('#economy7-slider') })
      .filter(function(n) { return n });

    if (!slider.length) { return; }

    economy7Slider = noUiSlider.create(slider[0], {
      start: [50],
      step: 1,
      range: {
        'min': 0,
        'max': 100
      }
    });

    economy7Slider.on('update', function() {
      app.ports.setEconomy7Usage.send(arguments[0][0]);
    });
  }

  function insertPowershiftSlider(nodes) {
    var slider = nodes
      .map(function(n) { return n.querySelector && n.querySelector('#powershift-slider') })
      .filter(function(n) { return n });

    if (!slider.length) { return; }

    powershiftSlider = noUiSlider.create(slider[0], {
      start: [20, 80],
      connect: true,
      step: 1,
      range: {
        'min': 0,
        'max': 100
      }
    });

    powershiftSlider.on('update', function() {
      app.ports.setPowershiftUsage.send(arguments[0]);
    });
  }

  function setTariffsWidth(nodes) {
    var tariffList = nodes
      .map(function(n) { return n.querySelector && n.querySelector('fieldset') })
      .filter(function(n) { return n });

    if (!tariffList.length) { return; }

    var container = document.querySelector('.container');
    var paddingL = getComputedStyle(container, null).getPropertyValue('padding-left');
    var paddingR = getComputedStyle(container, null).getPropertyValue('padding-right');
    var width = container.clientWidth - parseInt(paddingL, 10) - parseInt(paddingR, 10);

    [].forEach.call(document.querySelectorAll('fieldset'), function(el) {
      var child = el.querySelector('div');
      if (!child) return;
      child.style.width = width + 'px';
      child.style.overflowX = 'auto';
    });
  }

  $(document).ready(function() {
    $('html, body, body > div').animate({ scrollTop: 0 });
  });
}
